export default __webpack_public_path__ + "static/media/icon-progress1.05caf54c.svg";